class CoreSelectQuery extends HTMLElement {

    constructor() {
        super();
        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        console.log('<core-select-query> value chnage', e.target.value, this._name );
        const currentUrl = new URL(window.location);
        const searchParams = currentUrl.searchParams;
        searchParams.set(this._name, e.target.value);
        if (this.hasAttribute('data-params')) {
            const params = JSON.parse(this.getAttribute('data-params'));
            for (let k in params) {
                searchParams.set(k, params[k]);
            }
        }
        let hash = '';
        if (this.hasAttribute('data-hash')) {
            hash = '#' + this.getAttribute('data-hash')
        }

        currentUrl.search = searchParams.toString();
        currentUrl.hash = hash
        window.location.href = currentUrl.toString() ;
    }

    connectedCallback() {
        this.select = this.querySelector('select')
        this.label = this.querySelector('[label]')
        this.select?.addEventListener('change', this.onChange, false);
        this._name = this.getAttribute('name');
        if(this.label) {
            this.label.innerHTML = this.select.options[this.select.selectedIndex].text
        }
    }

    disconnectedCallback() {
        this.select?.removeEventListener('change', this.onChange, false);
    }

}

customElements.define('core-select-query', CoreSelectQuery);

console.log('<core-select-query> loaded');